import isEmpty from "lodash/isEmpty";
import { MessageRetailerOrBrandButton, additionalDataRequiredForContactingRetailerOrBrandCTA } from "../../shared/instantAnswerUtils";
import { NEED_MORE_INFO_ANSWER } from "./shared";
export var ChangeShippingAddressIA = function ChangeShippingAddressIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      return getAnswer(context, strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      return getAnswer(context, strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _MessageRetailerOrBra;
        return (_MessageRetailerOrBra = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra === void 0 ? void 0 : _MessageRetailerOrBra.label;
      },
      onClickFunctionBuilder: function onClickFunctionBuilder(context) {
        var _MessageRetailerOrBra2;
        return (_MessageRetailerOrBra2 = MessageRetailerOrBrandButton(context, strictLocalize)) === null || _MessageRetailerOrBra2 === void 0 ? void 0 : _MessageRetailerOrBra2.onClick;
      }
    },
    additionalRequiredData: additionalDataRequiredForContactingRetailerOrBrandCTA()
  };
};
var getAnswer = function getAnswer(context, strictLocalize) {
  var brandOrder = context.brandOrder,
    shippingContext = context.shippingContext;
  if (!brandOrder || !shippingContext) {
    return NEED_MORE_INFO_ANSWER(strictLocalize);
  }
  return !isEmpty(shippingContext.shipments) ? ORDER_SHIPPED_ALREADY(strictLocalize) : ORDER_NOT_SHIPPED_YET(strictLocalize);
};
var ORDER_SHIPPED_ALREADY = function ORDER_SHIPPED_ALREADY(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return YOUR_ORDER_HAS_ALREADY_SHIPPED(strictLocalize);
    },
    getDescription: function getDescription() {
      return [YOU_ARE_NOT_USUALLY_ABLE_TO_CHANGE_SHIPPING_ADDRESS(strictLocalize), WITH_EXCEPTION_1(strictLocalize), WITH_EXCEPTION_2(strictLocalize), CONTACT_BRAND_FOR_OPTIONS(strictLocalize)];
    }
  };
};
var ORDER_NOT_SHIPPED_YET = function ORDER_NOT_SHIPPED_YET(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return CONTACT_BRAND_TO_CHANGE_ADDRESS(strictLocalize);
    },
    getDescription: function getDescription() {
      return [CONTACT_BRAND_DIRECTLY(strictLocalize)];
    }
  };
};
var YOUR_ORDER_HAS_ALREADY_SHIPPED = function YOUR_ORDER_HAS_ALREADY_SHIPPED(strictLocalize) {
  return strictLocalize({
    id: "11RITG",
    defaultMessage: [{
      "type": 0,
      "value": "Je bestelling is al verzonden"
    }]
  });
};
var YOU_ARE_NOT_USUALLY_ABLE_TO_CHANGE_SHIPPING_ADDRESS = function YOU_ARE_NOT_USUALLY_ABLE_TO_CHANGE_SHIPPING_ADDRESS(strictLocalize) {
  return strictLocalize({
    id: "DDqFnG",
    defaultMessage: [{
      "type": 0,
      "value": "In de meeste gevallen kun je het verzendadres niet wijzigen nadat een bestelling is verzonden. Er zijn echter een paar uitzonderingen:"
    }]
  });
};
var WITH_EXCEPTION_1 = function WITH_EXCEPTION_1(strictLocalize) {
  return strictLocalize({
    id: "csBiWk",
    defaultMessage: [{
      "type": 0,
      "value": "1) Het merk heeft het etiket aangemaakt, maar de bestelling nog niet afgegeven bij de vervoerder."
    }]
  });
};
var WITH_EXCEPTION_2 = function WITH_EXCEPTION_2(strictLocalize) {
  return strictLocalize({
    id: "0VmuGe",
    defaultMessage: [{
      "type": 0,
      "value": "2) Het merk kan contact opnemen met de vervoerder en deze de bestelling laten omleiden (meestal tegen betaling)."
    }]
  });
};
var CONTACT_BRAND_FOR_OPTIONS = function CONTACT_BRAND_FOR_OPTIONS(strictLocalize) {
  return strictLocalize({
    id: "1s7sti",
    defaultMessage: [{
      "type": 0,
      "value": "Neem rechtstreeks contact op met het merk om je opties te bekijken."
    }]
  });
};
var CONTACT_BRAND_TO_CHANGE_ADDRESS = function CONTACT_BRAND_TO_CHANGE_ADDRESS(strictLocalize) {
  return strictLocalize({
    id: "k+WnvC",
    defaultMessage: [{
      "type": 0,
      "value": "Neem contact op met het merk om je verzendadres te wijzigen"
    }]
  });
};
var CONTACT_BRAND_DIRECTLY = function CONTACT_BRAND_DIRECTLY(strictLocalize) {
  return strictLocalize({
    id: "p8slbn",
    defaultMessage: [{
      "type": 0,
      "value": "Neem rechtstreeks contact op met het merk om een wijziging van het verzendadres voor deze bestelling aan te vragen. Je ontvangt een e-mail ter bevestiging van de wijzigingen zodra het merk de bestelling heeft bijgewerkt met je nieuwe bezorgadres."
    }]
  });
};